module.exports = __webpack_public_path__ + "ae33acae404631e997ef8d91dae08ccd.png";